import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LabelsManager from '@SiteComponents/LabelsManager'
import useClickOutsideListener from '@Utils/UseClickOutsideListener'

import {
  createLabel,
  createProjectLabels,
  deleteProjectLabels,
} from '@SiteModules/Label/actions'

import {
  closeLabelsManagerPopup,
  openLabelsManagerPopup,
} from '@SiteModules/Popup/actions'

import {
  getLabels,
  getLabelsInAllSelectedProjects,
  getLabelsInSomeButNotAllSelectedProjects,
} from '@SiteModules/Label/selectors'

import {
  getSelectedProjectTitles,
  getSelectedProjectIds,
} from '@SiteModules/Project/selectors'

import {
  getCurrentWorkspaceId,
} from '@SiteModules/Workspace/selectors'

import {
  getLabelsManagerPopupIsOpen,
} from '@SiteModules/Popup/selectors'

import './LabelsManagerPopup.scss'

const LabelsManagerPopup: React.FC = () => {
  const dispatch = useDispatch()

  const labels = useSelector(getLabels)
  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const selectedProjectTitles = useSelector(getSelectedProjectTitles)
  const selectedProjectIds = useSelector(getSelectedProjectIds)
  const labelsInAllSelectedProjects = useSelector(getLabelsInAllSelectedProjects)
  const labelsInSomeButNotAllSelectedProjects = useSelector(getLabelsInSomeButNotAllSelectedProjects)
  const LabelsManagerPopupIsOpen = useSelector(getLabelsManagerPopupIsOpen)

  const setOpenLabelsManagerPopup = (newOpenLabelsManagerPopup: boolean) => {
    newOpenLabelsManagerPopup ? dispatch(openLabelsManagerPopup()) : dispatch(closeLabelsManagerPopup())
  }

  useClickOutsideListener('LabelsManagerPopup', setOpenLabelsManagerPopup, LabelsManagerPopupIsOpen)

  const handleAssignLabels = (e: React.ChangeEvent<HTMLInputElement>, labelId: number, shouldCloseLabelsManager: boolean) => {
    const payload = { labelId, selectedProjectIds }
    e.target.checked ? dispatch(createProjectLabels(payload)) : dispatch(deleteProjectLabels(payload))

    if (shouldCloseLabelsManager) {
      dispatch(closeLabelsManagerPopup())
    }
  }

  const handleCreateAndAssignLabel = (caption: string) => {
    dispatch(createLabel({ caption, workspaceId: currentWorkspaceId, projectIdsForAssignment: selectedProjectIds }))
    dispatch(closeLabelsManagerPopup())
  }

  return (
    <div className="LabelsManagerPopup">
      <LabelsManager
        labels={labels}
        selectedLabelIds={labelsInAllSelectedProjects}
        indeterminateLabelIds={labelsInSomeButNotAllSelectedProjects}
        selectedProjectTitles={selectedProjectTitles}
        changeSelectedLabels={handleAssignLabels}
        createLabel={handleCreateAndAssignLabel}
        isForSelectedProjects
      />
    </div>
  )
}

export default LabelsManagerPopup
